import "../../css/blocks/services-grid.css";
import { editorIntegration } from "../modules/editor-integration";

function initServicesGrid(): void {
  const servicesGridBlocks = document.querySelectorAll(".services-grid");

  if (servicesGridBlocks.length) {
    // Initialize block-specific functionality here
    // Currently no interactive functionality, but ready for future enhancements
  }
}

// Register with editor integration for consistent initialization
editorIntegration.register("services-grid", initServicesGrid);